var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-card',{attrs:{"name":"trip.overview","error":_vm.error,"rounded":""}},[_c('trip-chart',{attrs:{"start":_vm.start,"end":_vm.end,"waypoints":_vm.waypoints,"annotations":_vm.annotations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }